import angular from 'angular';
import statusIndicatorComponent from './statusIndicator.component';
import StatusIndicatorService from './statusIndicator.service';

let statusIndicatorModule = angular.module('statusIndicator', []).component('statusIndicator', statusIndicatorComponent);
statusIndicatorModule.service('statusIndicatorService', StatusIndicatorService);


export default statusIndicatorModule;



// WEBPACK FOOTER //
// ./app/components/statusIndicator/statusIndicator.js